<app-main-layout>
  <section class="flex flex-col gap-3">
    <app-card>
      <app-card-header
        title="Aktivitäten"
        [iconPath]="'assets/icons/calendar-dots.svg'"
        [showLoadingSpinner]="requestState() === RequestStateEnum.PENDING"
      />

      <section class="flex flex-col gap-2 mb-2">
        <app-button
          text="Aktivität erstellen"
          [fullWidth]="true"
          (clicked)="openCreateActivityModal()"
        />

        <app-paginator
          [intervalType]="PaginatorIntervalTypeEnum.WEEK"
          (paginationChange)="handleTimeIntevalEvent($event)"
        />
      </section>

      <section class="flex flex-col border-b border-light-grey">
        <div class="grid w-full grid-cols-[45%_45%_10%] p-3 text-dark-grey">
          <span class="font-medium">Datum</span>
          <span class="font-medium">Traingseinheit</span>
        </div>

        @for (activity of activities(); track activity.id) {
          <div
            class="grid w-full grid-cols-[45%_45%_10%] p-3 border-t border-light-grey text-dark-grey"
          >
            <span>{{ activity.scheduledDate | dayjsFormat: 'dateWithAbbrWeekday' }}</span>
            <span>{{ getActivityTypeLabel(activity.type) }}</span>
            <div
              class="flex justify-center items-center bg-gray-100 px-1 rounded"
              (click)="openEditActivityModal(activity)"
            >
              <app-icon
                path="assets/icons/dots-three.svg"
                color="var(--dark-grey)"
              />
            </div>
          </div>
        } @empty {
          <app-no-entries-placeholder text="Keine Aktivitäten verfügbar" />
        }
      </section>

      @if (total() > pageSize()) {
        <mat-paginator
          aria-label="Seite auswählen"
          [length]="total()"
          [pageSize]="pageSize()"
          [hidePageSize]="true"
          [pageIndex]="pageIndex()"
          (page)="handlePageEvent($event)"
        />
      }
    </app-card>
  </section>
</app-main-layout>
